import createSymbol from 'lib/core/createSymbol';

const createAuthSymbol = createSymbol('USER');

export default {
  SET_USER: createAuthSymbol('SET_USER'),
  RESET_USER_STATE: createAuthSymbol('RESET_USER_STATE')
};
